import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import img from '../Assets/Group 184.png'
function Contact() {
  return (
    <>
        <Navbar/>
         <div className='AboutUs-banner'>
        <h3>Contact Us</h3>
        <p>Customized ASIC & SOC Solutions with Optimized Cost</p>

        </div>
        <div className='contact-div'>
<div className='contact-div-left'>
<div>

<h4>Get In Touch</h4>
<h6>Customized ASIC & SOC Solutions with Optimized Cost</h6>
</div>
<div className='contact-info'>
    <div className='contact-info-circle'>
<i class="bi bi-telephone-fill"></i>
    </div>
    <div className='contact-info-text'>

    <h3>Call</h3>
    <p>+91 99029-78741</p>
    </div>
</div>

<div className='contact-info'>
    <div className='contact-info-circle'>
<i class="bi bi-envelope-fill"></i>
    </div>
    <div className='contact-info-text'>

    <h3>Mail</h3>
    <p>hr@semicave.com</p>
    </div>
</div>
<div className='contact-info'>
    <div className='contact-info-circle'>
<i class="bi bi-geo-alt-fill"></i>
    </div>
    <div className='contact-info-text'>

    <h3>Address</h3>
    <p>Ground floor, PFS Club House,<br/> Marathahalli Main Rd, R.J.Gardens,<br/> Lakshminarayana Pura, EPIP Zone, <br/> Chinnapanna  Halli, Bengaluru,<br/> Karnataka 560037</p>
    </div>
</div>

        </div>
        <div className='contact-div-right'>
<img src={img}/>
        </div>
        </div>
        <div className='map'>

<iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3888.133489803748!2d77.69963042454647!3d12.963308815061078!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sGround%20floor%2C%20PFS%20Club%20House%2C%20Marathahalli%20Main%20Rd%2C%20R.J.Gardens%2C%20Lakshminarayana%20Pura%2C%20EPIP%20Zone%2C%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20Chinnapanna%20%20Halli%2C%20Bengaluru%2C%20Karnataka%20560037!5e0!3m2!1sen!2sin!4v1749299387805!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
        <Footer/>
    </>
  )
}

export default Contact